import React, { useEffect } from "react";
import Heading from "../common/ui/Heading";
import Gallery from "./Gallery";
import Hero from "../common/components/Hero";

const GalleryMain = () => {
  useEffect(() => {
    document.getElementById("title-page").innerHTML = "Make My Way | Gallery";
  }, []);
  return (
    <div>
      <Hero value={7} />
      <div
        id="gallery-top"
        className="container py-14 sm:py-16 md:py-24 lg:py-28 xl:py-[140px] mb-48"
      >
        <Heading className={`pt-1 text-center`}>GALLERY</Heading>
        <Gallery />
      </div>
    </div>
  );
};

export default GalleryMain;
